




































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import BulkGenerateReportingPeriodsRequest from '@/models/ReportingPeriods/BulkGenerateReportingPeriodsRequest';

@Component({ name: 'ReportingPeriodGenerate' })
export default class extends GiganautVueDialog {
	entity = new BulkGenerateReportingPeriodsRequest();
	valid = false;
	showStartDatePicker = false;

	@Watch('dialog')
	onDialogChanged(val: boolean) {
		if (val) {
			this.entity = new BulkGenerateReportingPeriodsRequest();
			this.entity.fiscalYear = new Date().getFullYear();
			this.entity.numberOfPeriods = 13;
			this.entity.periodLengthDays = 28;
		}
	}

	async generate() {
		if (!(this.$refs.form as any).validate()) return;
		await AgencySettingsModule.bulkGenerateReportingPeriods(this.entity);
		this.dialog = false;
		this.$emit('generated');
	}
}
